import { Button } from "@/components/ui/button";
import { CalendarCheck, Loader2 } from "lucide-react";

const T = {
  no: { title: "Bookingforespørsel – kontroller", machine: "Maskin", problem: "Problem", time: "Ønsket tid", contact: "Kontakt",
    fee: "Diagnostikk: {fee} kr inkl. mva (fast pris, belastes uansett utfall). Endelig reparasjonspris først etter diagnostikk.",
    note: "Dette er en forespørsel – verkstedet bekrefter tidspunktet.", confirm: "Bekreft forespørsel" },
  ru: { title: "Запрос на запись – проверьте", machine: "Машина", problem: "Проблема", time: "Желаемое время", contact: "Контакт",
    fee: "Диагностика: {fee} NOK с НДС (фиксированная плата, взимается при любом результате). Окончательная цена ремонта — только после диагностики.",
    note: "Это запрос — мастерская подтвердит время.", confirm: "Подтвердить запрос" },
  en: { title: "Booking request – please check", machine: "Machine", problem: "Problem", time: "Preferred time", contact: "Contact",
    fee: "Diagnostics: {fee} NOK incl. VAT (fixed fee, charged regardless of outcome). Final repair price only after diagnostics.",
    note: "This is a request – the workshop will confirm the time.", confirm: "Confirm request" },
};

export default function VadimBookingCard({ draft, lang, busy, onConfirm }) {
  const t = T[lang] || T.no;
  const row = (label, value, id) => value ? (
    <div className="flex gap-2"><span className="text-[#3D2314]/60 w-24 shrink-0">{label}</span><span data-testid={id}>{value}</span></div>
  ) : null;
  return (
    <div className="mx-3 my-2 rounded-xl border border-[#D4A574] bg-[#FFF8F0] p-3 text-xs text-[#1A1A1A] space-y-1.5" data-testid="vadim-booking-card">
      <div className="font-semibold text-sm text-[#3D2314] flex items-center gap-1.5"><CalendarCheck className="h-4 w-4" />{t.title}</div>
      {row(t.machine, [draft.machine_brand, draft.machine_model].filter(Boolean).join(" "), "vadim-booking-machine")}
      {row(t.problem, draft.problem_description, "vadim-booking-problem")}
      {row(t.time, `${draft.preferred_date} ${draft.preferred_time}`, "vadim-booking-time")}
      {row(t.contact, [draft.name, draft.phone, draft.email].filter(Boolean).join(" · "), "vadim-booking-contact")}
      <p className="text-[#3D2314]/80 pt-1" data-testid="vadim-booking-fee">{t.fee.replace("{fee}", draft.diagnostics_fee_nok ?? 1600)}</p>
      <p className="text-[#3D2314]/60">{t.note}</p>
      <Button size="sm" disabled={busy} onClick={onConfirm} data-testid="vadim-booking-confirm-btn"
        className="w-full mt-1 bg-[#3D2314] hover:bg-[#3D2314]/90 text-white">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : t.confirm}
      </Button>
    </div>
  );
}
